import { render, staticRenderFns } from "./AjaxCodeError.vue?vue&type=template&id=fb1cb0ec&"
import script from "./AjaxCodeError.vue?vue&type=script&lang=ts&"
export * from "./AjaxCodeError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports